import { useTranslation } from "react-i18next";
import { composeBookingChildName } from "../../utils/childBooking";

/**
 * Patient name block on the public (technician / nurse / therapist) visit pages.
 *
 * Child booking: the visit is for the CHILD, so the child's name is shown with a "Child" pill and
 * the account holder follows as the Guardian — the same split the lab technician page already
 * makes. Self booking: exactly the single name line the page showed before.
 *
 * @param booking      The public order payload (carries `is_for_child` + `child_*`).
 * @param guardianName The account holder's display name, as the page already formats it.
 * @param nameStyle    The page's existing style for the name line, so nothing shifts visually.
 */
export default function PublicPatientName({ booking, guardianName, nameStyle }) {
  const { t } = useTranslation();
  const childName = composeBookingChildName(booking);
  if (!childName) return <p style={nameStyle}>{guardianName}</p>;
  return (
    <>
      <p style={{ ...nameStyle, display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
        <span>{childName}</span>
        <span
          style={{
            fontSize: "11px",
            background: "#0cbdbd",
            color: "#fff",
            padding: "2px 8px",
            borderRadius: "10px",
            fontWeight: 500,
          }}
        >
          {t("childBooking.childBadge", "Child")}
        </span>
      </p>
      <p style={{ fontSize: "13px", color: "#6b7280", margin: "0 0 6px" }}>
        {t("childBooking.guardian", "Guardian")}:{" "}
        <span style={{ color: "#1f2937", fontWeight: 500 }}>{guardianName}</span>
      </p>
    </>
  );
}
